const loadFile = async function loadFile(moduleFileName) {
  const loader = await import(/* webpackChunkName: "[request]" */ `../../modules/${moduleFileName}.js`);
  return loader;
};

/**
 * Lazily load a modules/* entry after first interaction, or after `timer` ms
 * once the document is ready (whichever comes first).
 */
const lazyLoadModule = (moduleFileName, timer = 100, options) =>
  new Promise((resolve) => {
    let loaded = false;

    const init = () => {
      if (loaded) return;
      loaded = true;

      document.removeEventListener('scroll', initOnEvent);
      document.removeEventListener('mousemove', initOnEvent);
      document.removeEventListener('touchstart', initOnEvent);

      loadFile(moduleFileName).then((LoadedModule) => {
        LoadedModule.init(options).then(() => {
          setTimeout(() => resolve(), 50);
        });
      });
    };

    function initOnEvent() {
      init();
    }

    document.addEventListener('scroll', initOnEvent, { once: true, passive: true });
    document.addEventListener('mousemove', initOnEvent, { once: true });
    document.addEventListener('touchstart', initOnEvent, { once: true, passive: true });

    const scheduleIdleLoad = () => {
      setTimeout(() => {
        if (!loaded) init();
      }, timer);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleIdleLoad, { once: true });
    } else {
      scheduleIdleLoad();
    }
  });

export default lazyLoadModule;
